import React, { useEffect, useState } from "react";

import { MenuItem, Select } from "@mui/material";

import {
    getMicrosoftBingURL,
    postAuthorizeMicrosoftBing,
} from "helpers/destinations/microsoftBing";

import LoginButton from "components/molecules/LoginButton";

const MicrosoftBingDestination = ({
    setMicrosoftBingData,
    setMicrosoftBingAuthenticated,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [accounts, setAccounts] = useState([]);
    const [partnerInstallID, setPartnerInstallID] = useState(null);

    const [selectedAccount, setSelectedAccount] = useState(null);

    const onLoginSuccess = async (data) => {
        setIsLoading(true);
        const response = await postAuthorizeMicrosoftBing({
            code: data.code,
            state: data.state,
        });
        setAccounts(response?.data?.accounts ?? []);
        setPartnerInstallID(response?.data?.partner_install_id ?? null);
        if (response?.status) {
            setIsAuthenticated(true);
            setMicrosoftBingAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        setMicrosoftBingData({
            selectedAccountId: selectedAccount,
            selectedAccountName: accounts.find(
                (account) => account.id === selectedAccount,
            )?.name,
            partnerInstallID,
        });
    }, [selectedAccount, partnerInstallID, setMicrosoftBingData, accounts]);

    return (
        <div>
            {isAuthenticated && (
                <Select
                    label="Account"
                    value={selectedAccount}
                    onChange={(e) => setSelectedAccount(e.target.value)}
                    disabled={!accounts?.length}
                    fullWidth
                >
                    {accounts.map((account) => (
                        <MenuItem key={account.id} value={account.id}>
                            {account.number
                                ? `${account.name} (${account.number})`
                                : account.name}
                        </MenuItem>
                    ))}
                </Select>
            )}
            {!isAuthenticated && (
                <LoginButton
                    code="msoffline"
                    getAuthUrl={() =>
                        getMicrosoftBingURL().then((r) =>
                            r?.status && r?.data?.url ? r.data.url : null,
                        )
                    }
                    onAuthUrlError={() => setIsLoading(false)}
                    paramNames={["code", "state"]}
                    onSuccess={onLoginSuccess}
                    dataTransform={(params) => ({
                        code: params.code,
                        state: params.state,
                    })}
                    logoSrc="/assets/images/typeImages/bing.png"
                    buttonText="Connect Microsoft Ads"
                    disabled={false}
                    isLoadingExternal={isLoading}
                />
            )}
        </div>
    );
};

export default MicrosoftBingDestination;
